import { head, last, takeRightWhile, negate, toUpper } from 'lodash/fp';

const hasColon = (part: string) => part.indexOf(':') > -1;
const doesntHaveColon = negate(hasColon);

const tokenizeQuery = (
    query: string,
): {
    filters: Array<{
        type: string;
        value: string;
    }>;
    query: string;
} => {
    const parts = query.split(' ');

    const filterDirectives = parts.filter(hasColon).map((p) => {
        const filterParts = p.split(':');

        return {
            type: toUpper(head(filterParts) as string),
            value: toUpper(last(filterParts) as string),
        };
    });

    const searchQuery = takeRightWhile(doesntHaveColon, parts).join(' ');

    return {
        filters: filterDirectives,
        query: searchQuery,
    };
};

export default tokenizeQuery;
